(function () {
  var timerInterval = null;

  function startCartTimer() {
    var duration = 600; // 10 minutes in seconds
    var display = document.getElementById("cart-timer-countdown");
    var timerBox = document.getElementById("cart-timer");

    if (!display || !timerBox) return;

    // Always show timer
    timerBox.style.display = "block";

    // Get end time from sessionStorage (or reset if expired)
    var endTime = sessionStorage.getItem("cart-timer-end");

    if (!endTime || Date.now() > parseInt(endTime, 10)) {
      // start new 10 min
      endTime = Date.now() + duration * 1000;
      sessionStorage.setItem("cart-timer-end", endTime);
    } else {
      endTime = parseInt(endTime, 10);
    }

    // Clear old interval if exists
    if (timerInterval) {
      clearInterval(timerInterval);
      timerInterval = null;
    }

    // Start fresh interval
    timerInterval = setInterval(function () {
      var remaining = Math.floor((endTime - Date.now()) / 1000);

      if (remaining <= 0) {
        clearInterval(timerInterval);
        timerInterval = null;
        sessionStorage.removeItem("cart-timer-end");

        if (timerBox) timerBox.remove(); // hide after 10 min
        return;
      }

      var minutes = Math.floor(remaining / 60);
      var secs = remaining % 60;

      minutes = minutes < 10 ? "0" + minutes : minutes;
      secs = secs < 10 ? "0" + secs : secs;

      display.innerHTML = "<strong>" + minutes + ":" + secs + "</strong>";
    }, 1000);
  }

  // Run on cart update + DOM load
  document.addEventListener("cart:updated", startCartTimer);
  document.addEventListener("DOMContentLoaded", startCartTimer);

  // For themes without "cart:updated"
  var observer = new MutationObserver(function () {
    if (document.querySelector("#cart-timer")) {
      startCartTimer();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
// https://naila.uk/cart/cart/56023196041598:3,56023186080126:1

// free product add js

// document.addEventListener('DOMContentLoaded', function () {
//   const NAIL_GROWTH_PEN_ID = 56201504096638;
//   const GLASS_FILE_ID = 56023186080126;

//   console.log("🔍 Gift script loaded");

//   // 🔑 Main function
//   async function ensureGift() {
//     try {
//       const res = await fetch('/cart.js');
//       const cart = await res.json();

//       const nailPenItem = cart.items.find(item => item.variant_id == NAIL_GROWTH_PEN_ID);
//       const glassFileItem = cart.items.find(item => item.variant_id == GLASS_FILE_ID);

//       const nailPenQty = nailPenItem ? nailPenItem.quantity : 0;
//       const hasGlassFile = !!glassFileItem;

//       console.log(`🛒 NailPen=${nailPenQty}, GlassFile=${hasGlassFile}`);

//       // ➕ Add Glass File if eligible
//       if (nailPenQty >= 3 && !hasGlassFile) {
//         console.log("✅ Adding Glass File...");
//         await fetch('/cart/add.js', {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({ id: GLASS_FILE_ID, quantity: 1 })
//         });
//         refreshCartDrawer();
//       }

//       // ❌ Remove Glass File if not eligible
//       if (nailPenQty < 3 && hasGlassFile) {
//         console.log("🧹 Removing Glass File...");
//         await fetch('/cart/change.js', {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({ id: glassFileItem.key, quantity: 0 })
//         });
//         refreshCartDrawer();
//       }
//     } catch (err) {
//       console.error("❌ Gift check failed:", err);
//     }
//   }

//   // 🔄 Refresh cart drawer (Dawn)
//   function refreshCartDrawer() {
//     console.log("🔄 Refreshing cart drawer...");
//     fetch('/?section_id=cart-drawer')
//       .then(res => res.text())
//       .then(html => {
//         const parser = new DOMParser();
//         const doc = parser.parseFromString(html, 'text/html');
//         const newDrawer = doc.querySelector('cart-drawer');
//         const currentDrawer = document.querySelector('cart-drawer');

//         if (newDrawer && currentDrawer) {
//           currentDrawer.innerHTML = newDrawer.innerHTML;
//           currentDrawer.classList.remove('is-empty');
//           console.log("✅ Drawer updated");
//         }
//       })
//       .catch(err => console.error('❌ Drawer refresh error:', err));
//   }

//   // --- 👇 Make it reactive ---
//   // Run once on load
//   ensureGift();

//   // Run after any cart AJAX call
//   const origFetch = window.fetch;
//   window.fetch = async function(resource, config) {
//     const url = typeof resource === 'string' ? resource : resource.url || '';
//     const isCartAction = /\/cart\//.test(url);

//     const res = await origFetch(resource, config);

//     if (isCartAction) {
//       // wait for theme’s own UI update first
//       setTimeout(ensureGift, 150);
//     }
//     return res;
//   };

//   // Run when Dawn emits events
//   document.addEventListener('cart:updated', ensureGift);
//   document.addEventListener('cart:change', ensureGift);
// });


